// extracted by mini-css-extract-plugin
export var DemoCard = "index-module--DemoCard--uJbQu";
export var open = "index-module--open--05xNi";